import React, { FC, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { makePath } from '../../helpers/path'
import { Prefix } from '../../@types/prefix'
import { useLocation } from 'react-router'
import { Icon } from '@iconify/react'
import Alert from '../Home/Alert'
import ModalPromotions from '../Home/ModalPromotions'
import ModalSupport from '../Home/ModalSupport'

interface BottomBarProps {
	prefix?: Prefix
}
const BottomBar: FC<BottomBarProps> = ({ prefix }) => {
	const loc = useLocation()
	const playgameMotion = prefix?.playgameMotion === "" || prefix?.playgameMotion === "dance" ? "dance" : prefix?.playgameMotion;

	const [openAlert, setOpenAlert] = useState<boolean>(false)
	const handleAlert = () => setOpenAlert(!openAlert)

	const [openSupport, setOpenSupport] = useState<boolean>(false)
	const handleModalSupport = () => setOpenSupport(!openSupport)

	const [showMenuSupport, setShowMenuSupport] = useState<boolean>(true)

	useEffect(() => {
		if (prefix) {
			const isNullishSocialMedia = prefix?.socialMedia ? Object.values(prefix?.socialMedia).every(value => {
				if (value === "") {
					return true;
				}
				return false;
			}) : true;
			setShowMenuSupport(isNullishSocialMedia)
		}
	}, [prefix])

	return (
		<div className='bottombar-mobile'>
			<ul className="nav-menu">
				<li className="nav-item">
					<Link to={makePath('/home')} className={`nav-link ${loc.pathname === '/home' && 'active'} `}>
						{loc.pathname === '/home' ?
							<Icon icon="fluent:home-32-filled" width={26} style={{ marginBottom: 4, color: 'var(--color-primary)' }} /> :
							<Icon icon="fluent:home-32-regular" width={26} style={{ marginBottom: 4 }} />
						}
						<span>หน้าหลัก</span>
					</Link>
				</li>
				<li className="nav-item">
					<Link to={makePath('/login')} className={`nav-link`}>
						<Icon icon="hugeicons:gift" width={26} style={{ marginBottom: 4 }} />
						<span>โปรโมชั่น</span>
					</Link>
				</li>
				<li className="nav-item middle-item">
					<Link
						to={makePath('/login')}
						className={`nav-link`}
					>
						<div className={`icon-button-container ${playgameMotion}`}>
							{prefix?.playgameImage ?
								<img className="icon-center" src={prefix?.playgameImage} alt="icon" /> :
								<img className="icon-center" src={`/icons/3d/dice.png`} alt="icon" />
							}
						</div>
						<span>เข้าสู่ระบบ</span>
					</Link>
				</li>
				<li className="nav-item">
					<Link
						to={(!prefix?.functions.hasOwnProperty("offRegister") || !prefix?.functions['offRegister']) ? makePath('/register') : makePath('/login')}
						className={`nav-link`}
					>
						<Icon icon="solar:user-outline" width={26} style={{ marginBottom: 4 }} />
						<span>สมัครสมาชิก</span>
					</Link>
				</li>
				{/* {prefix?.socialMedia.line && (
					<li className="nav-item">
						<a href={prefix?.socialMedia.line} className={`nav-link`} target="_blank" rel="noreferrer">
							<Icon icon="hugeicons:customer-support" width={26} style={{ marginBottom: 4 }} />
							<span>ติดต่อเรา</span>
						</a>
					</li>
				)} */}
				{/* check link support */}
				{!showMenuSupport && (
					// <li className="nav-item">
					// 	<Link
					// 		to="#"
					// 		onClick={modalSupport}
					// 		className={`nav-link`}
					// 	>
					// 		<img src={`/icons/new/help.svg`} alt="icon" />
					// 		<span>ติดต่อเรา</span>
					// 	</Link>
					// </li>
					<li className="nav-item">
						<div className={`nav-link`} onClick={handleModalSupport}>
							<Icon icon="hugeicons:customer-support" width={26} style={{ marginBottom: 4 }} />
							<span>ติดต่อเรา{prefix?.lineLink}</span>
						</div>
					</li>
				)}
				{prefix?.lineLink && showMenuSupport ? (
					<li className="nav-item">
						<a href={prefix.lineLink} className={`nav-link`} target="_blank" rel="noreferrer">
							<Icon icon="hugeicons:customer-support" width={26} style={{ marginBottom: 4 }} />
							<span>ติดต่อเรา</span>
						</a>
					</li>
				) : (!prefix?.lineLink && showMenuSupport &&
					// <li className="nav-item">
					// 	<Link
					// 		to={makePath('/login')}
					// 		className={`nav-link`}
					// 	>
					// 		<img src={`/icons/new/help.svg`} alt="icon" />
					// 		<span>ติดต่อเรา</span>
					// 	</Link>
					// </li>
					<li className="nav-item">
						<a href={makePath('/login')} className={`nav-link`} target="_blank" rel="noreferrer">
							<Icon icon="hugeicons:customer-support" width={26} style={{ marginBottom: 4 }} />
							<span>ติดต่อเรา</span>
						</a>
					</li>
				)}
			</ul>



			<Alert
				isOpen={openAlert}
				onClose={() => setOpenAlert(false)} />

			<ModalSupport
				isOpen={openSupport}
				onClose={() => setOpenSupport(false)} />
		</div>
	)
}

export default BottomBar
